import * as React from 'react';
import { connect } from 'react-redux';
import { RequestApiResult, requestAPIActions, IsAuthentificatedState } from 'loopback-react-request';
import { UserDataBaseModel } from 'franke-trough-dependencies';

export interface UserDataDispatcherProps {
  authenticator: IsAuthentificatedState;
  dispatch: any;
  userData: RequestApiResult<UserDataBaseModel>;
}

const dispatchKey = 'userData';

class UserDataDispatcherContainer extends React.Component<UserDataDispatcherProps, any> {

  componentDidMount() {
    this.dispatchUserData();
  }

  public render() {
    return null;
  }

  private dispatchUserData() {
    const {
      authenticator,
    } = this.props;
    if (authenticator.accessToken) {
      this.props.dispatch(requestAPIActions.load(dispatchKey, {
        url: `/Users/${authenticator.accessToken.userId}/userData`
      }));
    }
  }
}

interface StateProps {
  authenticator: IsAuthentificatedState;
  userData: RequestApiResult<UserDataBaseModel>;
}

export const UserDataDispatcher = connect((state: StateProps) => ({
  authenticator: state.authenticator,
  userData: state.userData,
}))(UserDataDispatcherContainer);
